import Vue from "vue";
export * from './BaseVue'
export * from './BaseApprove'
export * from './types'
export * from './global'
export * from './main'
export * from './store'
export * from './CASign'
export * from 'vue-property-decorator'

export * from "vuex-class"
export {CASign} from './CASign'

export const EventBus = new Vue();